import generousBigMeals from '../img/GenerousBigMeals2025.png';
// import generousBigMeals from '../img/Meals/2025/Squre/BigMealCombos/Ge';

//added for 2025
import CaribbeanJerkChickenComboSquare from '../img/Meals/2025/Squre/BigMealCombos/CaribbeanJerkChickenCombo.png';
import CaribbeanJerkChickenComboRect from '../img/Meals/2025/Rect/BigMealCombos/CaribbeanJerkChickenCombo.png';

//added for 2025
import ChickenTenderPlatterComboSquare from '../img/Meals/2025/Squre/BigMealCombos/ChickenTenderPlatterCombo.png';
import ChickenTenderPlatterComboRect from '../img/Meals/2025/Rect/BigMealCombos/ChickenTenderPlatterCombo.png';

//added for 2025
import ChickenSkewersComboSquare from '../img/Meals/2025/Squre/BigMealCombos/ChickenSkewersCombo.png';
import ChickenSkewersComboRect from '../img/Meals/2025/Rect/BigMealCombos/ChickenSkewersCombo.png';

//added for 2025
import BBQChickenWingMealComboSqure from '../img/Meals/2025/Squre/BigMealCombos/BBQChickenWingMealCombo.png';
import BBQChickenWingMealComboRect from '../img/Meals/2025/Rect/BigMealCombos/BBQChickenWingMealCombo.png';


//added for 2025
import ChickenWingMealComboSquare from '../img/Meals/2025/Squre/BigMealCombos/ChickenWingMealCombo.png';
import ChickenWingMealComboRect from '../img/Meals/2025/Rect/BigMealCombos/ChickenWingMealCombo.png';

import JuicyGrilledChickenBreastComboSquare from '../img/Meals/2025/Squre/BigMealCombos/JuicyGrilledChickenBreastCombo.png';
import JuicyGrilledChickenBreastComboRect from '../img/Meals/2025/Rect/BigMealCombos/JuicyGrilledChickenBreastCombo.png';

//added for 2025
import LemonHerbChickenWingMealComboSqure from '../img/Meals/2025/Squre/BigMealCombos/LemonHerbChickenWingMealCombo.png';
import LemonHerbChickenWingMealComboRecat from '../img/Meals/2025/Rect/BigMealCombos/LemonHerbChickenWingMealCombo.png';


//added for 2025
import TurmericChickenComboSqure from '../img/Meals/2025/Squre/BigMealCombos/TurmericChickenCombo.png';
import TurmericChickenComboRect from '../img/Meals/2025/Rect/BigMealCombos/TurmericChickenCombo.png';


//added for 2025
import StirFriedChickenSqure from '../img/Meals/2025/Squre/BigMealCombos/StirFriedChicken.png';
import StirFriedChickenRect from '../img/Meals/2025/Squre/BigMealCombos/StirFriedChicken.png';



//added for 2025
import BBQChickenComboSqure from '../img/Meals/2025/Squre/BigMealCombos/BBQChickenCombo.png';
import BBQChickenComboRect from '../img/Meals/2025/Squre/BigMealCombos/BBQChickenWingMealCombo.png';


//added for 2025
import LemonHerbChickenComboSqure from '../img/Meals/2025/Squre/BigMealCombos/LemonHerbChickenCombo.png';
import LemonHerbChickenComboRect from '../img/Meals/2025/Squre/BigMealCombos/LemonHerbChickenCombo.png';

//added for 2025
import ChickenTendersComboSqure from '../img/Meals/2025/Squre/BigMealCombos/ChickenTendersCombo.png';
import ChickenTendersComboRect from '../img/Meals/2025/Squre/BigMealCombos/ChickenTendersCombo.png';

// //added for 2025
// import JuicyGrilledChickenBreastComboSqure from '../img/Meals/2025/Squre/BigMealCombos/TurmericChickenCombo.png';
// import JuicyGrilledChickenBreastComboRect from '../img/Meals/2025/Rect/BigMealCombos/TurmericChickenCombo.png';


import CrispyFriedChickenWingMealComboSqure from '../img/Meals/2025/Squre/BigMealCombos/CrispyFriedChickenWingMealCombo.png';
import CrispyFriedChickenWingMealComboRect from '../img/Meals/2025/Rect/BigMealCombos/CrispyFriedChickenWingMealCombo.png';



//added for 2025
import BeefSteakComboSquare from '../img/Meals/2025/Squre/BigMealCombos/BeefSteakCombo.png';
import BeefSteakComboRect from '../img/Meals/2025/Rect/BigMealCombos/BeefSteakCombo.png';

//added for 2025
import MushroomSteakComboSquare from '../img/Meals/2025/Squre/BigMealCombos/MushroomSteakCombo.png';
import MushroomSteakComboRect from '../img/Meals/2025/Rect/BigMealCombos/MushroomSteakCombo.png';

//added for 2025
import PepperSteakSquare from '../img/Meals/2025/Squre/BigMealCombos/PepperSteakCombo.png';
import PepperSteakRect from '../img/Meals/2025/Rect/BigMealCombos/PepperSteakCombo.png';


import GrilledCajunTilapiaSquare from '../img/Meals/2025/Squre/BigMealCombos/GrilledTilapiaCombo.png';
import GrilledCajunTilapiaRect from '../img/Meals/2025/Rect/BigMealCombos/GrilledTilapiaCombo.png';

import GralicBeefUgaliDelightSqure from '../img/Meals/2025/Squre/BigMealCombos/GralicBeefUgaliDelight.png';
import GralicBeefUgaliDelightRect from '../img/Meals/2025/Squre/BigMealCombos/GralicBeefUgaliDelight.png';


import CajunTilapiaComboSqure from '../img/Meals/2025/Squre/BigMealCombos/CajunTilapiaCombo.png';
import CajunTilapiaComboRect from '../img/Meals/2025/Rect/BigMealCombos/GrilledCajunTilapiaCombo.png';

import FishFingersSquare from '../img/Meals/2025/Squre/BigMealCombos/FishFingerChips.png';
import FishFingersRect from '../img/Meals/2025/Rect/BigMealCombos/FishFingersCombo.png';

import stirFriedTilapiaCombo from '../img/Meals/StirFriedTilapiaCombo.png';
import stirFriedTilapiaComboRect from '../img/Meals/StirFriedTilapiaComboRect.png';

import GrilledTilapiaSquare from '../img/Meals/GrilledTilapiaSquare.png';
import GrilledTilapiaRect from '../img/Meals/GrilledTilapiaRect.png';

import RusticaGrilledFishFilletSquare from '../img/Meals/2025/Squre/BigMealCombos/RusticaGrilledFishFillet.png';
import RusticaGrilledFishFilletRect from '../img/Meals/2025/Rect/BigMealCombos/RusticaGrilledFishFilletCombo.png';



import MadrasBeefCurryComboSqure from '../img/Meals/2025/Squre/BigMealCombos/MadrasBeefCurryCombo.png';
import MadrasBeefCurryComboRect from '../img/Meals/2025/Rect/BigMealCombos/MadrasBeefCurryCombo.png';


import ClassicChickenKormaComboSqure from '../img/Meals/2025/Squre/BigMealCombos/ClassicChickenKormaCombo.png';
import ClassicChickenKormaComboRect from '../img/Meals/2025/Rect/BigMealCombos/ClassicChickenKormaCombo.png';


import CJSignatureFishCurryComboSqure from '../img/Meals/2025/Squre/BigMealCombos/CJsSignatureFishCurryCombo.png';
import CJSignatureFishCurryCombo from '../img/Meals/2025/Rect/BigMealCombos/CJsSignatureFishCurryCombo.png';


import SplitDecisionComboSqure from '../img/Meals/2025/Squre/BigMealCombos/SplitDecisionCombo.png';
import SplitDecisionCombo1Rect from '../img/Meals/2025/Rect/BigMealCombos/SplitDecisionCombo.png';


import ThaiPeanutChickenCurryCombo1Squre from '../img/Meals/2025/Squre/BigMealCombos/ThaiPeanutChickenCurryCombo.png';
import ThaiPeanutChickenCurryCombo1Rect from '../img/Meals/2025/Rect/BigMealCombos/ThaiPeanutChickenCurryCombo.png';


// Tandoor items

import ChickenKalmiKebab from '../img/Meals/2025/Squre/Tandoor/1.png';
import ChickenKalmiKebabreact from '../img/Meals/2025/Rect/Tandoor/1.png';

import TandooriChicken from '../img/Meals/2025/Squre/Tandoor/2.png';
import TandooriChickenReact from '../img/Meals/2025/Rect/Tandoor/2.png';

import ChickenTikkaMasala from '../img/Meals/2025/Squre/Tandoor/3.png';
import ChickenTikkaMasalaReact from '../img/Meals/2025/Rect/Tandoor/3.png';

import BeefBotiKebab from '../img/Meals/2025/Squre/Tandoor/4.png';
import BeefBotiKebabreact from '../img/Meals/2025/Rect/Tandoor/4.png';

import ButterChicken from '../img/Meals/2025/Squre/Tandoor/5.png';
import ButterChickenReact from '../img/Meals/2025/Rect/Tandoor/5.png';

import GarlicMurgTikka from '../img/Meals/2025/Rect/Tandoor/6.png';
import GarlicMurgTikkaRect from '../img/Meals/2025/Rect/Tandoor/6.png';

import FishTikka from '../img/Meals/2025/Squre/Tandoor/9.png';
import FishTikkaReact from '../img/Meals/2025/Rect/Tandoor/9.png';

import TandooriPatter from '../img/Meals/2025/Rect/Tandoor/8.png';
import TandooriPatterReact from '../img/Meals/2025/Rect/Tandoor/8.png';


// Tandoor items


import MadrasBeefCurrySquare from '../img/Meals/MadrasBeefCurrySquare.png';
import MadrasBeefCurryRect from '../img/Meals/MadrasBeefCurryRect.png';
import ClassicChickenKormaSquare from '../img/Meals/ClassicChickenKormaSquare.png';
import ClassicChickenKormaRect from '../img/Meals/ClassicChickenKormaRect.png';
import CjsSignatureFishCurrySquare from '../img/Meals/CjsSignatureFishCurrySquare.png';
import CjsSignatureFishCurryRect from '../img/Meals/CjsSignatureFishCurryRect.png';
import ThaiPeanutChickenCurryComboSquare from '../img/Meals/ThaiPeanutChickenCurryComboSquare.png';
import ThaiPeanutChickenCurryComboRect from '../img/Meals/ThaiPeanutChickenCurryComboRect.png';
import SplitDecisionComboSquare from '../img/Meals/SplitDecisionComboSquare.png';
import SplitDecisionComboRect from '../img/Meals/SplitDecisionComboRect.png';
import bananaCakeSlice from '../cjs-imgs/BananaCakeSlice.svg';




//Meals Starters & Appetisers

import chickenWings from '../img/Meals/chickenWings.png';
import chickenWingsRect from '../img/Meals/chickenWingsRect.png';
import samosaSpringRollPlatter from '../img/Meals/samosaSpringRollPlatter.png';
import samosaSpringRollPlatterRect from '../img/Meals/samosaSpringRollPlatterRect.png';

//Meals Bits & Bites
import samosasRect from '../img/Meals/samosasRect.png';
import vegetableSpringRollsRect from '../img/Meals/vegetableSpringRollsRect.png';
import chickenSpringRollsRect from '../img/Meals/chickenSpringRollsRect.png';
import friedPlantainRect from '../img/Meals/friedPlantainRect.png';
import beefSausagesRect from '../img/Meals/beefSausagesRect.png';
import masalaChipsRect from '../img/Meals/masalaChipsRect.png';
import chipsRect from '../img/Meals/chipsRect.png';
import onionRingsRect from '../img/Meals/onionRingsRect.png';
import mincedMeatCheeseFriesRect from '../img/Meals/mincedMeatCheeseFriesRect.png';
import loadedPotatoFriesRect from '../img/Meals/loadedPotatoFriesRect.png';
import roastedPlantainRect from '../img/Meals/roastedPlantainRect.png';
import friedSpinachRect from '../img/Meals/friedSpinachRect.png';
import steamedVegetablesRect from '../img/Meals/steamedVegetablesRect.png';
import samosas from '../img/Meals/samosas.png';
import vegetableSpringRolls from '../img/Meals/vegetableSpringRolls.png';
import chickenSpringRolls from '../img/Meals/chickenSpringRolls.png';
import friedPlantain from '../img/Meals/friedPlantain.png';
import beefSausages from '../img/Meals/beefSausages.png';
import masalaChips from '../img/Meals/masalaChips.png';
import chips from '../img/Meals/chips.png';
import onionRings from '../img/Meals/2025/Squre/Bites/2.png';
import mincedMeatCheeseFries from '../img/Meals/mincedMeatCheeseFries.png';
import loadedPotatoFries from '../img/Meals/loadedPotatoFries.png';
// import roastedPlantain from '../img/Meals/roastedPlantain.png';
import roastedPlantain from '../img/Meals/roastedPlantain.png';
import friedSpinach from '../img/Meals/friedSpinach.png';
import steamedVegetables from '../img/Meals/steamedVegetables.png';
import GarlicParmesanFriesRect from '../img/Meals/2025/Rect/Bits/1.png';
import GarlicParmesanFriesSqure from '../img/Meals/2025/Squre/Bites/1.png';

import chickenPie from '../img/Meals/chickenPie.png';
import chickenPieRect from '../img/Meals/chickenPieRect.png';

import SeafoodPizzaRect from '../img/Meals/2025/Rect/Pizza/1.png';
import SeafoodPizzaSqure from '../img/Meals/2025/Squre/Pizza/1.png';
//Meals Soulful Soups

import creamOfMushroomSoup from '../img/Meals/2025/Squre/SoulfulSoups/1.png';
import creamOfMushroomSoupRect from '../img/Meals/2025/Rect/SoulfulSoups/1.png';

import creamOfTomatoSoup from '../img/Meals/2025/Squre/SoulfulSoups/2.png';
import creamOfTomatoSoupRect from '../img/Meals/2025/Rect/SoulfulSoups/2.png';

import butternutSquashSoup from '../img/Meals/2025/Squre/SoulfulSoups/3.png';
import butternutSquashSoupRect from '../img/Meals/2025/Rect/SoulfulSoups/3.png';

import clearChickenVegSoup from '../img/Meals/2025/Squre/SoulfulSoups/4.png';
import clearChickenVegSoupRect from '../img/Meals/2025/Rect/SoulfulSoups/4.png';

import thaiChickenNoodleSoup from '../img/Meals/2025/Squre/SoulfulSoups/5.png';
import thaiChickenNoodleSoupRect from '../img/Meals/2025/Rect/SoulfulSoups/5.png';

import clearChickenMushroomSoup from '../img/Meals/2025/Squre/SoulfulSoups/6.png';
import clearChickenMushroomSoupRect from '../img/Meals/2025/Rect/SoulfulSoups/6.png';


import ChickenMinestroneSoupSqure from '../img/Meals/2025/Squre/SoulfulSoups/7.png';
import ChickenMinestroneSoupRect from '../img/Meals/2025/Rect/SoulfulSoups/7.png';

//Meals Our Famous Salads

import chipotleChickenBowl from '../img/Meals/2025/Squre/OurFamousSalads/1.png';
import chipotleChickenBowlRect from '../img/Meals/2025/Rect/OurFamousSalads/1.png';

import chipotleFishBowl from '../img/Meals/2025/Squre/OurFamousSalads/2.png';
import chipotleFishBowlRect from '../img/Meals/2025/Rect/OurFamousSalads/2.png';

import mediterraneanSalmonSalad from '../img/Meals/2025/Squre/OurFamousSalads/3.png';
import mediterraneanSalmonSaladRect from '../img/Meals/2025/Rect/OurFamousSalads/3.png';

import cajunChickenSalad from '../img/Meals/2025/Squre/OurFamousSalads/4.png';
import cajunChickenSaladRect from '../img/Meals/2025/Rect/OurFamousSalads/4.png';

import cjsMixedGreenSalad from '../img/Meals/2025/Squre/OurFamousSalads/5.png';
import cjsMixedGreenSaladRect from '../img/Meals/2025/Rect/OurFamousSalads/5.png';

import caesarSalad from '../img/Meals/2025/Squre/OurFamousSalads/6.png';
import caesarSaladRect from '../img/Meals/2025/Rect/OurFamousSalads/6.png';

import turkeyWaldorf from '../img/Meals/2025/Squre/OurFamousSalads/7.png';
import turkeyWaldorfRect from '../img/Meals/2025/Rect/OurFamousSalads/7.png';

import bbqRanchChickenSalad from '../img/Meals/2025/Squre/OurFamousSalads/8.png';
import bbqRanchChickenSaladRect from '../img/Meals/2025/Rect/OurFamousSalads/8.png';

import cobbSalad from '../img/Meals/2025/Squre/OurFamousSalads/9.png';
import cobbSaladRect from '../img/Meals/2025/Rect/OurFamousSalads/10.png';

import SantaFeSalad from '../img/Meals/2025/Squre/OurFamousSalads/10.png';
import SantaFeSaladRect from '../img/Meals/2025/Rect/OurFamousSalads/9.png';

import GrilledSteakAvocadoSalad from '../img/Meals/2025/Squre/OurFamousSalads/GrilledSteakAvocadoSalad.png';

//Meals Scrumptious Sandwiches

import chickenAvocadoMLT from '../img/Meals/chickenAvocadoMLT.png';
import chickenAvocadoMLTRect from '../img/Meals/chickenAvocadoMLTRect.png';
import cubanSandwich from '../img/Meals/cubanSandwich.png';
import cubanSandwichRect from '../img/Meals/cubanSandwichRect.png';
import classicCheeseTomato from '../img/Meals/classicCheeseTomato.png';
import classicCheeseTomatoRect from '../img/Meals/classicCheeseTomatoRect.png';
import bbqChickenSandwich from '../img/Meals/bbqChickenSandwich.png';
import bbqChickenSandwichRect from '../img/Meals/bbqChickenSandwichRect.png';
import grilledVegetableClub from '../img/Meals/grilledVegetableClub.png';
import grilledVegetableClubRect from '../img/Meals/grilledVegetableClubRect.png';
import phillyCheeseSteak from '../img/Meals/phillyCheeseSteak.png';
import phillyCheeseSteakRect from '../img/Meals/phillyCheeseSteakRect.png';
import cjsClubSandwich from '../img/Meals/cjsClubSandwich.png';
import cjsClubSandwichRect from '../img/Meals/cjsClubSandwichRect.png';

import BuffaloChickenWrapSqure from '../img/Meals/2025/Squre/ScrumptiousSandwiches/8.png';
import BuffaloChickenWrapRect from '../img/Meals/2025/Rect/ScrumptiousSandwiches/8.png';


//Meals Big-Mouth Burgers

import hawaiianBBQBurger from '../img/Meals/hawaiianBBQBurger.png';
import hawaiianBBQBurgerRect from '../img/Meals/hawaiianBBQBurgerRect.png';
import friedCrispyChickenBurger from '../img/Meals/friedCrispyChickenBurger.png';
import friedCrispyChickenBurgerRect from '../img/Meals/friedCrispyChickenBurgerRect.png';
import mexicanBurger from '../img/Meals/mexicanBurger.png';
import mexicanBurgerRect from '../img/Meals/mexicanBurgerRect.png';
import bigIsBig from '../img/Meals/bigIsBig.png';
import bigIsBigRect from '../img/Meals/bigIsBigRect.png';
import bbqBurger from '../img/Meals/bbqBurger.png';
import bbqBurgerRect from '../img/Meals/bbqBurgerRect.png';
import beefBurger from '../img/Meals/beefBurger.png';
import beefBurgerRect from '../img/Meals/beefBurgerRect.png';
import chickenBurger from '../img/Meals/chickenBurger.png';
import chickenBurgerRect from '../img/Meals/chickenBurgerRect.png';

import chickenBurgerSingle from '../img/Meals/2025/Squre/BigMouthBurgers/13.png';
import chickenBurgerSingleRect from '../img/Meals/2025/Rect/BigMouthBurgers/13.png';

import vegetableBurger from '../img/Meals/vegetableBurger.png';
import vegetableBurgerRect from '../img/Meals/vegetableBurgerRect.png';


import FishBurgerSqure from '../img/Meals/2025/Squre/BigMouthBurgers/8.png';
import FishBurgerRect from '../img/Meals/2025/Rect/BigMouthBurgers/8.png';


import BuffaloBurgeSqure from '../img/Meals/2025/Squre/BigMouthBurgers/12.png';
import BuffaloBurgerRect from '../img/Meals/2025/Rect/BigMouthBurgers/12.png';

//Meals Chicken

import caribbeanJerkChicken from '../img/Meals/2025/Squre/Chicken/1.png';
import caribbeanJerkChickenRect from '../img/Meals/2025/Rect/Chicken/1.png';

import stirFriedChicken from '../img/Meals/2025/Squre/Chicken/2.png';
import stirFriedChickenRect from '../img/Meals/2025/Rect/Chicken/2.png';

import juicyGrilledChickenBreast from '../img/Meals/2025/Squre/Chicken/3.png';
import juicyGrilledChickenBreastRect from '../img/Meals/2025/Rect/Chicken/3.png';



import mushroomGrilledChickenBreast from '../img/Meals/2025/Squre/Chicken/4.png';
import mushroomGrilledChickenBreastRect from '../img/Meals/2025/Rect/Chicken/4.png';

import chickenWingMeal from '../img/Meals/2025/Squre/Chicken/5.png';
import chickenWingMealRect from '../img/Meals/2025/Rect/Chicken/5.png';

import BBQChickenWingMeal from '../img/Meals/2025/Squre/Chicken/6.png';
import BBQChickenWingMealRect from '../img/Meals/2025/Rect/Chicken/6.png';

import LemonHerbChickenWingMealSqure from '../img/Meals/2025/Squre/Chicken/7.png';
import LemonHerbChickenWingMealRect from '../img/Meals/2025/Rect/Chicken/7.png';


import CrispyFriedChickenWingMealSqure from '../img/Meals/2025/Squre/Chicken/8.png';
import CrispyFriedChickenWingMealRect from '../img/Meals/2025/Rect/Chicken/8.png';


import chickenSkewers from '../img/Meals/2025/Squre/Chicken/9.png';
import chickenSkewersRect from '../img/Meals/2025/Rect/Chicken/9.png';

import chickenTendersPlatter from '../img/Meals/2025/Squre/Chicken/10.png';
import chickenTendersPlatterRect from '../img/Meals/2025/Rect/Chicken/10.png';

import TurmericChickenSqure from '../img/Meals/2025/Squre/Chicken/11.png';
import TurmericChickenRect from '../img/Meals/2025/Rect/Chicken/11.png';

import BBQChickenSqure from '../img/Meals/2025/Squre/Chicken/12.png';
import BBQChickenRect from '../img/Meals/2025/Rect/Chicken/12.png';



import LemonHerbChickenSqure from '../img/Meals/2025/Squre/Chicken/13.png';
import LemonHerbChickenRect from '../img/Meals/2025/Rect/Chicken/13.png';

//Meal Fish

import grilledTilapia from '../img/Meals/2025/Squre/Fish/1.png';
import grilledTilapiaRect from '../img/Meals/2025/Rect/Fish/1.png';

import stirFriedTilapia from '../img/Meals/2025/Squre/Fish/2.png';
import stirFriedTilapiaRect from '../img/Meals/2025/Rect/Fish/2.png';

import grilledSalmon from '../img/Meals/2025/Squre/Fish/3.png';
import grilledSalmonRect from '../img/Meals/2025/Rect/Fish/3.png';

import grilledCajunTilapia from '../img/Meals/2025/Squre/Fish/4.png';
import grilledCajunTilapiaRect from '../img/Meals/2025/Rect/Fish/4.png';

import rusticaGrilledFishFillet from '../img/Meals/2025/Squre/Fish/5.png';
import rusticaGrilledFishFilletRect from '../img/Meals/2025/Rect/Fish/5.png';

import fishFingers from '../img/Meals/2025/Squre/Fish/6.png';
import fishFingersRect from '../img/Meals/2025/Rect/Fish/6.png';

import GrilledRedSnapper from '../img/Meals/2025/Squre/Fish/7.png';
import GrilledRedSnapperRect from '../img/Meals/2025/Rect/Fish/7.png';

import CajunRedSnapper from '../img/Meals/2025/Squre/Fish/8.png';
import CajunRedSnapperRect from '../img/Meals/2025/Rect/Fish/8.png';

import GrilledSalmon from '../img/Meals/2025/Squre/Fish/9.png';
import GrilledSalmonRect from '../img/Meals/2025/Rect/Fish/9.png';



import shrimpPasta from '../img/Meals/shrimpPasta.png';
import shrimpPastaRect from '../img/Meals/shrimpPastaRect.png';

//Meal Beef

import beefSteak from '../img/Meals/2025/Squre/Beef/1.png';
import beefSteakRect from '../img/Meals/2025/Squre/Beef/1.png';

import mushroomBeefSteak from '../img/Meals/2025/Squre/Beef/2.png';
import mushroomBeefSteakRect from '../img/Meals/2025/Squre/Beef/2.png';

import pepperBeefSteak from '../img/Meals/2025/Squre/Beef/3.png';
import pepperBeefSteakRect from '../img/Meals/2025/Squre/Beef/3.png';

import GralicBeefUgaliDelight from '../img/Meals/2025/Squre/Beef/4.png';
import GralicBeefUgaliDelight2025Rect from '../img/Meals/2025/Squre/Beef/4.png';

//Meal Curries

import madrasBeefCurry from '../img/Meals/2025/Squre/Curries/1.png';
import madrasBeefCurryRect from '../img/Meals/2025/Rect/Curries/1.png';

import classicChickenKorma from '../img/Meals/2025/Squre/Curries/2.png';
import classicChickenKormaRect from '../img/Meals/2025/Rect/Curries/2.png';

import theTrio from '../img/Meals/2025/Squre/Curries/3.png';
import theTrioRect from '../img/Meals/2025/Rect/Curries/3.png';

import shrimpCurry from '../img/Meals/2025/Squre/Curries/4.png';
import shrimpCurryRect from '../img/Meals/2025/Rect/Curries/4.png';

import signatureFishCurry from '../img/Meals/2025/Squre/Curries/5.png';
import signatureFishCurryRect from '../img/Meals/2025/Rect/Curries/5.png';

import splitDecision from '../img/Meals/2025/Squre/Curries/6.png';
import splitDecisionRect from '../img/Meals/2025/Rect/Curries/6.png';

import thaiPeanutChickenCurry from '../img/Meals/2025/Squre/Curries/7.png';
import thaiPeanutChickenCurryRect from '../img/Meals/2025/Rect/Curries/7.png';

import vegetableCurry from '../img/Meals/2025/Squre/Curries/8.png';
import vegetableCurryRect from '../img/Meals/2025/Rect/Curries/8.png';

import SalmonCurry from '../img/Meals/2025/Squre/Curries/9.png';
import SalmonCurryRect from '../img/Meals/2025/Rect/Curries/9.png';

// Meal Pasta

import chipotleShrimpPasta from '../img/Meals/2025/Squre/Pasta/1.png';
import chipotleShrimpPastaRect from '../img/Meals/2025/Rect/Pasta/1.png';

import chickenAlfredoPasta from '../img/Meals/2025/Squre/Pasta/2.png';
import chickenAlfredoPastaRect from '../img/Meals/2025/Rect/Pasta/2.png';

import chipotleChickenPasta from '../img/Meals/2025/Squre/Pasta/3.png';
import chipotleChickenPastaRect from '../img/Meals/2025/Rect/Pasta/3.png';

import pastaPrimavera from '../img/Meals/2025/Squre/Pasta/4.png';
import pastaPrimaveraRect from '../img/Meals/2025/Rect/Pasta/4.png';

import chickenPesto from '../img/Meals/2025/Squre/Pasta/5.png';
import chickenPestoRect from '../img/Meals/2025/Rect/Pasta/5.png';

import shrimpPasta1 from '../img/Meals/2025/Squre/Pasta/1.png';
import shrimpPastaRect1 from '../img/Meals/2025/Rect/Pasta/1.png';

import tuscanChicken from '../img/Meals/2025/Squre/Pasta/6.png';
import tuscanChickenRect from '../img/Meals/2025/Rect/Pasta/6.png';

import JerkChickenPastaSqure from '../img/Meals/2025/Squre/Pasta/7.png';
import JerkChickenPastaReact from '../img/Meals/2025/Rect/Pasta/7.png';

// Meal Mex-fix Imports
import southwesternQuesadilla from '../img/Meals/southwesternQuesadilla.png';
import southwesternQuesadillaRect from '../img/Meals/southwesternQuesadillaRect.png';
import softTacos from '../img/Meals/softTacos.png';
import softTacosRect from '../img/Meals/softTacosRect.png';
import vegetableMushroomQuesadilla from '../img/Meals/vegetableMushroomQuesadilla.png';
import vegetableMushroomQuesadillaRect from '../img/Meals/vegetableMushroomQuesadillaRect.png';
import sizzlingFajitas from '../img/Meals/sizzlingFajitas.png';
import sizzlingFajitasRect from '../img/Meals/sizzlingFajitasRect.png';
import vegetableSizzlingFajitas from '../img/Meals/vegetableSizzlingFajitas.png';
import vegetableSizzlingFajitasRect from '../img/Meals/vegetableSizzlingFajitasRect.png';

import SalmonFajitas from '../img/Meals/2025/Rect/Mix/1.png';
import SalmonFajitasRect from '../img/Meals/2025/Rect/Mix/1.png';

// Meal Pizza Imports
import nyamaFeastPizza from '../img/Meals/nyamaFeastPizza.png';
import nyamaFeastPizzaRect from '../img/Meals/nyamaFeastPizzaRect.png';
import margheritaPizza from '../img/Meals/margheritaPizza.png';
import margheritaPizzaRect from '../img/Meals/margheritaPizzaRect.png';
import vegetarianPizza from '../img/Meals/vegetarianPizza.png';
import vegetarianPizzaRect from '../img/Meals/vegetarianPizzaRect.png';
import mexicanChickenPizza from '../img/Meals/mexicanChickenPizza.png';
import mexicanChickenPizzaRect from '../img/Meals/mexicanChickenPizzaRect.png';
import superSupremeChickenPizza from '../img/Meals/superSupremeChickenPizza.png';
import superSupremeChickenPizzaRect from '../img/Meals/superSupremeChickenPizzaRect.png';
import chickenHawaiiPizza from '../img/Meals/2025/Squre/Pizza/2.png';
import chickenHawaiiPizzaRect from '../img/Meals/2025/Rect/Pizza/2.png';
import jerkChickenPizza from '../img/Meals/jerkChickenPizza.png';
import jerkChickenPizzaRect from '../img/Meals/jerkChickenPizzaRect.png';
import bbqChickenPizza from '../img/Meals/bbqChickenPizza.png';
import bbqChickenPizzaRect from '../img/Meals/bbqChickenPizzaRect.png';

// Kiddie Meals Imports
import kiddieChickenStrips from '../img/Meals/2025/Squre/KiddieMeals/1.png';
import kiddieChickenStripsRect from '../img/Meals/2025/Rect/KiddieMeals/1.png';

import kiddieChickenBurger from '../img/Meals/2025/Squre/KiddieMeals/2.png';
import kiddieChickenBurgerRect from '../img/Meals/2025/Rect/KiddieMeals/2.png';

import kiddieTommyFishFingers from '../img/Meals/2025/Squre/KiddieMeals/3.png';
import kiddieTommyFishFingersRect from '../img/Meals/2025/Rect/KiddieMeals/3.png';

import kiddiePastaMaster from '../img/Meals/2025/Squre/KiddieMeals/4.png';
import kiddiePastaMasterRect from '../img/Meals/2025/Rect/KiddieMeals/4.png';

import kiddieSausageWorld from '../img/Meals/2025/Squre/KiddieMeals/5.png';
import kiddieSausageWorldRect from '../img/Meals/2025/Rect/KiddieMeals/5.png';

import kiddieFries from '../img/Meals/2025/Squre/KiddieMeals/6.png';
import kiddieFriesRect from '../img/Meals/2025/Rect/KiddieMeals/6.png';

import KiddiePancake from '../img/Meals/kiddiePancake.png';
import KiddiePancakeRect from '../img/Meals/kiddiePancakeRect.png';



import KiddiePanFriedTilapiaFillet from '../img/Meals/KiddiePanFriedTilapiaFillet.png';
import KiddiePanFriedTilapiaFilletRect from '../img/Meals/KiddiePanFriedTilapiaFilletRect.png';

import jerkAndJillChicken from '../img/Meals/2025/Squre/KiddieMeals/7.png';
import jerkAndJillChickenRect from '../img/Meals/2025/Rect/KiddieMeals/7.png';

import panFriedTilapiaFillet from '../img/Meals/2025/Squre/KiddieMeals/8.png';
import panFriedTilapiaFilletRect from '../img/Meals/2025/Rect/KiddieMeals/8.png';

// Extras Imports
import mashedPotatoes from '../img/Meals/mashedPotatoes.png';
import mashedPotatoesRect from '../img/Meals/mashedPotatoesRect.png';
import coleslaw from '../img/Meals/coleslaw.png';
import coleslawRect from '../img/Meals/coleslawRect.png';
import steamedRice from '../img/Meals/steamedRice.png';
import steamedRiceRect from '../img/Meals/steamedRiceRect.png';
import mexicanRice from '../img/Meals/mexicanRice.png';
import mexicanRiceRect from '../img/Meals/mexicanRiceRect.png';
import steamedVeggies from '../img/Meals/steamedVeggies.png';
import steamedVeggiesRect from '../img/Meals/steamedVeggiesRect.png';
import sideSalad from '../img/Meals/sideSalad.png';
import sideSaladRect from '../img/Meals/sideSaladRect.png';
import salsa from '../img/Meals/salsa.png';
import salsaRect from '../img/Meals/salsaRect.png';
import creamyMushroomSauce from '../img/Meals/creamyMushroomSauce.png';
import creamyMushroomSauceRect from '../img/Meals/creamyMushroomSauceRect.png';
import chapati from '../img/Meals/chapati.png';
import chapatiRect from '../img/Meals/chapatiRect.png';
import beefStrips from '../img/Meals/beefStrips.png';
import beefStripsRect from '../img/Meals/beefStripsRect.png';
const GenerousBigMeals =
{
  "ImageURL": generousBigMeals,
  "Name": "Generous Big Meals",
  "OpenTime": "11:30 AM - 11:00 PM",
  "Status": "Opened",
  "type": [
    {
      "ImageURL": CaribbeanJerkChickenComboSquare,
      "Name": "Caribbean Jerk Chicken Combo",
      "category": "Big Meal Combos",
      "dec": "Marinated chicken on bone Caribbean style, grilled to perfection, served with salsa, plantains, salad, 1000 island dressing and ranchero sauce. With your choice of chips or rice or mashed potatoes and your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": CaribbeanJerkChickenComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": ChickenTenderPlatterComboSquare,
      "Name": "Chicken Tender Platter Combo",
      "category": "Big Meal Combos",
      "dec": "Tender, crispy, breaded chicken strips served with honey mustard, chips and coleslaw along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": ChickenTenderPlatterComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": ChickenSkewersComboSquare,
      "Name": "Chicken Skewers Combo",
      "category": "Big Meal Combos",
      "dec": "Marinated chicken skewers served with sweet corn, plantain, salsa & brown gravy along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": ChickenSkewersComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    //added for 2025 BBQ Chicken Wing Meal Combo

    {
      "ImageURL": BBQChickenWingMealComboSqure,
      "Name": "BBQ Chicken Wing Meal Combo",
      "category": "Big Meal Combos",
      "dec": "Marinated grilled chicken wings hand tossed in BBQ sauce with carrots, cucumber & dipping sauce. Along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": BBQChickenWingMealComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    // {
    //   "ImageURL": ChickenWingMealComboSquare,
    //   "Name": "Chicken Wing Meal Combo",
    //   "category": "Big Meal Combos",
    //   "dec": "Marinated grilled chicken wings hand tossed in BBQ sauce with carrots, cucumber & dipping sauce. Along with your choice of fresh juice.",
    //   "KES": 2150,
    //   "RectImageURL": ChickenWingMealComboRect,
    //   "Upgrades": [
    //     { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },

    //     { name: "Substitute minced meat & cheese toppings", price: 280 },
    //     { name: "Substitute with Masala Chips", price: 200 },
    //     { name: "Substitute your fries with Sub Pasta", price: 280 },
    //     { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
    //     { name: "Substitute your fries with caesar salad", price: 280 },
    //     { name: "Add Onion Rings", price: 230 },
    //     { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
    //     { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
    //     { name: "Substitute with Garlic Parmesan Fries", price: 280 },
    //     { name: "Add Side Salad", price: 330 },
    //     { name: "Substitute your fries to Plantain", price: 230 },
    //     { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
    //   ]
    // },
    // {
    //   "ImageURL": JuicyGrilledChickenBreastComboSquare,
    //   "Name": "Juicy Grilled Chicken Breast Combo",
    //   "category": "Big Meal Combos",
    //   "dec": "Tender and juicy marinated boneless chicken breast, cooked to perfection along with your choice of fresh juice.",
    //   "KES": 2150,
    //   "RectImageURL": JuicyGrilledChickenBreastComboRect,
    //   "Upgrades": [
    //     { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
    //     { name: "Substitute minced meat & cheese toppings", price: 280 },
    //     { name: "Substitute with Masala Chips", price: 200 },
    //     { name: "Substitute your fries with Sub Pasta", price: 280 },
    //     { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
    //     { name: "Substitute your fries with caesar salad", price: 280 },
    //     { name: "Add Onion Rings", price: 230 },
    //     { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
    //     { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
    //     { name: "Substitute with Garlic Parmesan Fries", price: 280 },
    //     { name: "Add Side Salad", price: 330 },
    //     { name: "Substitute your fries to Plantain", price: 230 },
    //     { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
    //   ]
    // },

    {
      "ImageURL": LemonHerbChickenWingMealComboSqure,
      "Name": "Lemon & Herb Chicken Wing Meal Combo",
      "category": "Big Meal Combos",
      "dec": "Marinated grilled chicken wings hand tossed in juicy lemon and herb sauce served with carrots, cucumber & dipping sauce. Along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": LemonHerbChickenWingMealComboRecat,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    //added for 2025 Crispy Fried Chicken Wing Meal Combo
    {
      "ImageURL": CrispyFriedChickenWingMealComboSqure,
      "Name": "Crispy Fried Chicken Wing Meal Combo",
      "category": "Big Meal Combos",
      "dec": "Tender, crispy and breaded chicken wings served with carrots, cucumber & dipping sauce. Along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": CrispyFriedChickenWingMealComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },


    //added for 2025 Turmeric Chicken Combo
    {
      "ImageURL": TurmericChickenComboSqure,
      "Name": "Turmeric Chicken Combo",
      "category": "Big Meal Combos",
      "dec": "Turmeric chicken with fried rice served with yellow sauce and salsa along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": TurmericChickenComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    //added for 2025 Juicy Grilled Chicken Breast Combo
    {
      "ImageURL": JuicyGrilledChickenBreastComboSquare,
      "Name": "Juicy Grilled Chicken Breast Combo",
      "category": "Big Meal Combos",
      "dec": "Tender and juicy marinated boneless chicken breast, cooked to perfection along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": JuicyGrilledChickenBreastComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    //added for 2025 Stir Fried Chicken
    {
      "ImageURL": StirFriedChickenSqure,
      "Name": "Stir Fried Chicken Combo",
      "category": "Big Meal Combos",
      "dec": "Strips of tender juicy chicken breast served with caeser salad, spinach and plantain along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": StirFriedChickenRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    //added for 2025 BBQ Chicken Combo

    {
      "ImageURL": BBQChickenComboSqure,
      "Name": "BBQ Chicken Combo",
      "category": "Big Meal Combos",
      "dec": "Oven roasted chicken on bone smothered with a sweet & tangy BBQ sauce, served with chips, garlic bread and coleslaw",
      "KES": 2150,
      "RectImageURL": BBQChickenComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    //added for 2025 Lemon & Herb Chicken Comboombo

    {
      "ImageURL": LemonHerbChickenComboSqure,
      "Name": "Lemon & Herb Chicken Combo",
      "category": "Big Meal Combos",
      "dec": "Tender juicy lemon and herb marinated chicken on bone cooked to perfection served with chapati, pilau, steamed vegetables, cucumber salsa and garden peas curry.",
      "KES": 2150,
      "RectImageURL": LemonHerbChickenComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    //added for 2025 Chicken Tenders Combo

    {
      "ImageURL": ChickenTendersComboSqure,
      "Name": "Chicken Tenders Combo",
      "category": "Big Meal Combos",
      "dec": "Tender, crispy, breaded chicken strips served with honey mustard, chips and coleslaw.",
      "KES": 2150,
      "RectImageURL": ChickenTendersComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": BeefSteakComboSquare,
      "Name": "Beef Steak Combo",
      "category": "Big Meal Combos",
      "dec": "Tender and juicy beef fillet steak cooked to your preference. Served with crispy onion rings and choice of fries, mashed potato or rice. Along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": BeefSteakComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },



    {
      "ImageURL": MushroomSteakComboSquare,
      "Name": "Mushroom Steak Combo",
      "category": "Big Meal Combos",
      "dec": "Tender and juicy beef fillet steak cooked to your preference. Served with mushroom sauce and choice of fries, mashed potatoes or rice. Along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": MushroomSteakComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },



    {
      "ImageURL": PepperSteakSquare,
      "Name": "Pepper Steak Combo",
      "category": "Big Meal Combos",
      "dec": "Tender and juicy beef fillet steak cooked to your preference. Served with pepper sauce and choice of fries, mashed potatoes or rice. Along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": PepperSteakRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": GralicBeefUgaliDelightSqure,
      "Name": "Gralic Beef Ugali Delight Combo",
      "category": "Big Meal Combos",
      "dec": "Juicy diced beef sautéed with garlic and white onion, marinated in homemade spices, and served with ugali or your choice of carbohydrates.Along with your choice of fresh juice.",
      "KES": 2200,
      "RectImageURL": GralicBeefUgaliDelightRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": GrilledCajunTilapiaSquare,
      "Name": "Grilled Tilapia Combo",
      "category": "Big Meal Combos",
      "dec": "Fresh Lake Victoria grilled Tilapia fillet, grilled to perfection served with tangy rustica sauce. Along with your choice of fresh juice.",
      "KES": 2200,
      "RectImageURL": GrilledCajunTilapiaRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": CajunTilapiaComboSqure,
      "Name": "Cajun Tilapia Combo",
      "category": "Big Meal Combos",
      "dec": "Fresh Lake Victoria cajun spiced Tilapia fillet, grilled to perfection served with tangy rustica sauce. Along with your choice of fresh juice.",
      "KES": 2200,
      "RectImageURL": CajunTilapiaComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": FishFingersSquare,
      "Name": "Fish Finger & Chips Combo",
      "category": "Big Meal Combos",
      "dec": "Small and long pieces of fish, crumb fried and served with tartar sauce. Along with your choice of fresh juice.",
      "KES": 2200,
      "RectImageURL": FishFingersRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": stirFriedTilapiaCombo,
      "Name": "Stir Fry Tilapia Combo",
      "category": "Big Meal Combos",
      "dec": "Strips of fresh Tilapia served with caeser salad, spinach and plantain. Along with your choice of fresh juice.",
      "KES": 2200,
      "RectImageURL": stirFriedTilapiaComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    // {
    //   "ImageURL": GrilledTilapiaSquare,
    //   "Name": "Grilled Tilapia Combo",
    //   "category": "Big Meal Combos",
    //   "dec": "Fresh Lake Victoria Tilapia fillet grilled to perfection served with creamy pili pili sauce. Along with your choice of fresh juice.",
    //   "KES": 2150,
    //   "RectImageURL": GrilledTilapiaRect,
    //   "Upgrades": [
    //     { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
    //     { name: "Substitute minced meat & cheese toppings", price: 280 },
    //     { name: "Substitute with Masala Chips", price: 200 },
    //     { name: "Substitute your fries with Sub Pasta", price: 280 },
    //     { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
    //     { name: "Substitute your fries with caesar salad", price: 280 },
    //     { name: "Add Onion Rings", price: 230 },
    //     { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
    //     { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
    //     { name: "Substitute with Garlic Parmesan Fries", price: 280 },
    //     { name: "Add Side Salad", price: 330 },
    //     { name: "Substitute your fries to Plantain", price: 230 },
    //     { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
    //   ]
    // },
    {
      "ImageURL": RusticaGrilledFishFilletSquare,
      "Name": "Rustica Grilled Fish Fillet",
      "category": "Big Meal Combos",
      "dec": "Grilled Lake Victoria Tilapia fillet on avocado salsa served with tangy rustica sauce and black olives.",
      "KES": 2200,
      "RectImageURL": RusticaGrilledFishFilletRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": MadrasBeefCurryComboSqure,
      "Name": "Madras Beef Curry Combo",
      "category": "Big Meal Combos",
      "dec": "Mild homemade beef curry with a hint of yogurt served with steamed vegetables and mango chutney. With your choice of rice, fries, mashed potatoes along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": MadrasBeefCurryComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },


    {
      "ImageURL": ClassicChickenKormaComboSqure,
      "Name": "Classic Chicken Korma Combo",
      "category": "Big Meal Combos",
      "dec": "Creamy mild coconut chicken curry served with steamed vegetables and mango chutney. With your choice of rice, fries or mashed potatoes along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": ClassicChickenKormaComboRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": CJSignatureFishCurryComboSqure,
      "Name": "CJ’s Signature Fish Curry Combo",
      "category": "Big Meal Combos",
      "dec": "Fresh Lake Victoria Tilapia cubes simmered in a creamy mild coconut curry served with steamed vegetables and mango chutney. With your choice of rice or fries, mashed potatoes along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": CJSignatureFishCurryCombo,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": SplitDecisionComboSqure,
      "Name": "Split Decision Combo",
      "category": "Big Meal Combos",
      "dec": "Half madras beef curry and half chicken korma served with mango chutney. With your choice of rice, fries, mashed potatoes along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": SplitDecisionCombo1Rect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": ThaiPeanutChickenCurryCombo1Squre,
      "Name": "Thai Peanut Chicken Curry Combo",
      "category": "Big Meal Combos",
      "dec": "Boneless chicken cooked with peanut sauce and okra served with cinnamon plantains, salsa, salad and 1000 island dressing. With your choice of rice, fries or mashed potatoes along with your choice of fresh juice.",
      "KES": 2150,
      "RectImageURL": ThaiPeanutChickenCurryCombo1Rect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
// New Section for tandoor Chicken Combos

    {
      "ImageURL": ChickenKalmiKebab,
      "Name": "Chicken Kalmi Kebab",
      "category": "Flavors of the Tandoor",
      "dec": "A royal Mughlai delight made with succulent chicken marinated in yoghurt and aromatic spices.",
      "KES": 1800,
      "RectImageURL": ChickenKalmiKebabreact,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": TandooriChicken,
      "Name": "Tandoori Chicken",
      "category": "Flavors of the Tandoor",
      "dec": "Juicy chicken marinated in rich spices and yoghurt, cooked to perfection in a tandoor for smoky, charred flavor. Served with rice and naan.",
      "KES": 1800,
      "RectImageURL": TandooriChickenReact,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },


    {
      "ImageURL": ChickenTikkaMasala,
      "Name": "Chicken Tikka",
      "category": "Flavors of the Tandoor",
      "dec": "Juicy, spice-kissed chicken chunks chargrilled for that bold, fiery flavour you crave. Served with yellow gravy.",
      "KES": 1800,
      "RectImageURL": ChickenTikkaMasalaReact,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": BeefBotiKebab,
      "Name": "Beef Boti Kebab",
      "category": "Flavors of the Tandoor",
      "dec": "Juicy, spice-kissed beef cubes grilled over open flames for that perfect smoky char — CJ’s Beef Boti Kebab is bursts with bold, savory flavor in every bite. Served with naan and rice.",
      "KES": 1800,
      "RectImageURL": BeefBotiKebabreact,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": ButterChicken,
      "Name": "Butter Chicken",
      "category": "Flavors of the Tandoor",
      "dec": "A culinary masterpiece of marinated chicken slow-cooked in a luxurious blend of butter, tomatoes, cashews, and cream.",
      "KES": 1800,
      "RectImageURL": ButterChickenReact,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": GarlicMurgTikka,
      "Name": "Garlic Murg Tikka",
      "category": "Flavors of the Tandoor",
      "dec": "A delicate harmony of garlic and spice, this soft, juicy chicken tikka is roasted to a beautiful golden finish.",
      "KES": 1800,
      "RectImageURL": GarlicMurgTikkaRect,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": FishTikka,
      "Name": "Fish Tikka",
      "category": "Flavors of the Tandoor",
      "dec": "Tender fish fillets marinated in a vibrant blend of fresh herbs and spices, and green chutney – grilled to smoky perfection. Served with yellow gravy.",
      "KES": 1800,
      "RectImageURL": FishTikkaReact,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    {
      "ImageURL": TandooriPatter,
      "Name": "Tandoori Platter",
      "category": "Flavors of the Tandoor",
      "dec": "An opulent tandoori experience: tandoori chicken, kalmi kebab, chicken tikka, garlic murgh tikka, beef boti, and ajwaini fish tikka, flame-grilled to perfection.",
      "KES": 2100,
      "RectImageURL": TandooriPatterReact,
      "Upgrades": [
        { name: "Substitue your juice with milkshake “OR” lemonade “OR” fresh orange juice Sustitute your fries with Mince Meat & Cheese Fries  ", price: 280 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },



    //end of New Section for tandoor Chicken Combos




    {
      "ImageURL": chickenWings,
      "Name": "Chicken Wings",
      "category": "Starters & Appetisers",
      "dec": "Bone-in Chicken Wings Tossed in your choice of flavors: BBQ - Crispy Fried - Lemon & Herb",
      "KES": 1400,
      "RectImageURL": chickenWingsRect,
      "Upgrades": []
    },
    {
      "ImageURL": samosaSpringRollPlatter,
      "Name": "Samosa & Spring Roll Platter",
      "category": "Starters & Appetisers",
      "dec": "A platter of beef samosas, vegetable samosas, chicken spring rolls, and vegetable spring rolls. Served with plantains.",
      "KES": 950,
      "RectImageURL": samosaSpringRollPlatterRect,
      "Upgrades": []
    },
    {
      "ImageURL": samosas,
      "Name": "Samosas",
      "category": "Bits & Bites",
      "dec": "A pair of chicken or beef or vegetable deep fried stuffed pastry shells.",
      "KES": 350,
      "RectImageURL": samosasRect,
      "Upgrades": []
    },
    {
      "ImageURL": vegetableSpringRolls,
      "Name": "Vegetable Spring Rolls",
      "category": "Bits & Bites",
      "dec": "A pastry filled stirred fried vegetables served with sweet chilli sauce.",
      "KES": 350,
      "RectImageURL": vegetableSpringRollsRect,
      "Upgrades": []
    },
    {
      "ImageURL": chickenSpringRolls,
      "Name": "Chicken Spring Rolls",
      "category": "Bits & Bites",
      "dec": "A pastry filled with chicken & vegetables served with sweet chilli sauce.",
      "KES": 400,
      "RectImageURL": chickenSpringRollsRect,
      "Upgrades": []
    },
    {
      "ImageURL": friedPlantain,
      "Name": "Fried Plantain",
      "category": "Bits & Bites",
      "dec": "Deep fried sliced sweet gonjas.",
      "KES": 500,
      "RectImageURL": friedPlantainRect,
      "Upgrades": []
    },
    {
      "ImageURL": beefSausages,
      "Name": "Beef Sausages (A Pair)",
      "category": "Bits & Bites",
      "dec": "Seasoned and stuffed minced beef.",
      "KES": 350,
      "RectImageURL": beefSausagesRect,
      "Upgrades": []
    },
    {
      "ImageURL": masalaChips,
      "Name": "Masala Chips",
      "category": "Bits & Bites",
      "dec": "Chips tossed with fresh coriander, homemade masala sauce made of onions, cumin seeds, curry paste, tomato sauce and fresh cream.",
      "KES": 500,
      "RectImageURL": masalaChipsRect,
      "Upgrades": []
    },
    {
      "ImageURL": chips,
      "Name": "Chips",
      "category": "Bits & Bites",
      "dec": "Fresh cut potato strips, deep fried, seasoned with paprika, salt & garlic powder.",
      "KES": 350,
      "RectImageURL": chipsRect,
      "Upgrades": []
    },
    {
      "ImageURL": onionRings,
      "Name": "Onion Rings",
      "category": "Bits & Bites",
      "dec": "Crispy deep-fried flour-coated rings of onion.",
      "KES": 350,
      "RectImageURL": onionRings,
      "Upgrades": []
    },
    {
      "ImageURL": mincedMeatCheeseFries,
      "Name": "Minced Meat & Cheese Fries",
      "category": "Bits & Bites",
      "dec": "French fries, deep fried, seasoned, topped with minced meat and melted cheddar cheese.",
      "KES": 600,
      "RectImageURL": mincedMeatCheeseFriesRect,
      "Upgrades": []
    },
    {
      "ImageURL": loadedPotatoFries,
      "Name": "Loaded Potato Fries",
      "category": "Bits & Bites",
      "dec": "Loaded Potato Fries.",
      "KES": 600,
      "RectImageURL": loadedPotatoFriesRect,
      "Upgrades": []
    },
    {
      "ImageURL": roastedPlantain,
      "Name": "Roasted Plantain",
      "category": "Bits & Bites",
      "dec": "Roasted Plantain.",
      "KES": 500,
      "RectImageURL": roastedPlantainRect,
      "Upgrades": []
    },
    {
      "ImageURL": friedSpinach,
      "Name": "Fried Spinach",
      "category": "Bits & Bites",
      "dec": "Fried spinach.",
      "KES": 350,
      "RectImageURL": friedSpinachRect,
      "Upgrades": []
    },
    {
      "ImageURL": steamedVegetables,
      "Name": "Steamed Vegetables",
      "category": "Bits & Bites",
      "dec": "Steamed vegetables.",
      "KES": 350,
      "RectImageURL": steamedVegetablesRect,
      "Upgrades": []
    },
    {
      "ImageURL": GarlicParmesanFriesSqure,
      "Name": "Garlic Parmesan Fries",
      "category": "Bits & Bites",
      "dec": "Garlic parmesan fries",
      "KES": 600,
      "RectImageURL": GarlicParmesanFriesRect,
      "Upgrades": []
    },
    {
      "ImageURL": chickenPie,
      "Name": "Chicken Pie",
      "category": "Bits & Bites",
      "dec": "Chicken Pie",
      "KES": 350,
      "RectImageURL": chickenPieRect,
      "Upgrades": []
    },
    {
      "ImageURL": creamOfMushroomSoup,
      "Name": "Cream of Mushroom Soup",
      "category": "Soulful Soups",
      "dec": "Fresh homemade creamy mushroom soup. Accompanied with two bread rolls and butter.",
      "KES": 550,
      "RectImageURL": creamOfMushroomSoupRect,
      "Upgrades": []
    },
    {
      "ImageURL": creamOfTomatoSoup,
      "Name": "Cream of Tomato Soup",
      "category": "Soulful Soups",
      "dec": "Creamy tomato topped with bread croutons & dollop of cream. Accompanied with two bread rolls and butter.",
      "KES": 550,
      "RectImageURL": creamOfTomatoSoupRect,
      "Upgrades": []
    },
    {
      "ImageURL": butternutSquashSoup,
      "Name": "Butternut Squash Soup",
      "category": "Soulful Soups",
      "dec": "Fresh homemade soup prepared for each day of the week. Accompanied with two bread rolls and butter.",
      "KES": 550,
      "RectImageURL": butternutSquashSoupRect,
      "Upgrades": []
    },
    {
      "ImageURL": clearChickenVegSoup,
      "Name": "Clear Chicken & Veg Soup",
      "category": "Soulful Soups",
      "dec": "Fresh homemade soup prepared for each day of the week. Accompanied with two bread rolls and butter.",
      "KES": 550,
      "RectImageURL": clearChickenVegSoupRect,
      "Upgrades": []
    },
 
    {
      "ImageURL": thaiChickenNoodleSoup,
      "Name": "Thai Chicken & Noodle Soup",
      "category": "Soulful Soups",
      "dec": "Fresh homemade creamy Thai chicken and noodle soup. Accompanied with two bread rolls and butter.",
      "KES": 550,
      "RectImageURL": thaiChickenNoodleSoupRect,
      "Upgrades": []
    },
    {
      "ImageURL": clearChickenMushroomSoup,
      "Name": "Clear Chicken & Mushroom Soup",
      "category": "Soulful Soups",
      "dec": "Fresh homemade soup prepared for each day of the week. Accompanied with two bread rolls and butter.",
      "KES": 550,
      "RectImageURL": clearChickenMushroomSoupRect,
      "Upgrades": []
    },
    {
      "ImageURL": ChickenMinestroneSoupSqure,
      "Name": "Chicken Minestrone Soup",
      "category": "Soulful Soups",
      "dec": "Fresh homemade soup prepared for each day of the week. Accompanied with two bread rolls and butter.",
      "KES": 550,
      "RectImageURL": ChickenMinestroneSoupRect,
      "Upgrades": []
    },
    {
      "ImageURL": chipotleChickenBowl,
      "Name": "Chipotle Chicken Bowl",
      "category": "Our Famous Salads",
      "dec": "Mildly spiced juicy chicken served on a bowl of romaine lettuce with cilantro lime rice, avocado, black beans, sweet corn, onions and sautéed bell peppers drizzled with a delicious dressing.",
      "KES": 1300,
      "RectImageURL": chipotleChickenBowlRect,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },
    {
      "ImageURL": chipotleFishBowl,
      "Name": "Chipotle Fish Bowl",
      "category": "Our Famous Salads",
      "dec": "Mildly Spiced fish strips served on the bowl of romaine lettuce with cilantro lime rice, avocado, black beans, sweet corn, onions and sautéed bell peppers drizzled with a delicious dressing.",
      "KES": 1350,
      "RectImageURL": chipotleFishBowlRect,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },
    {
      "ImageURL": mediterraneanSalmonSalad,
      "Name": "Mediterranean Salmon Salad",
      "category": "Our Famous Salads",
      "dec": "Super simple grilled salmon served on a bed of refreshing Mediterranean salad with grape fruit marmalade.",
      "KES": 2400,
      "RectImageURL": mediterraneanSalmonSaladRect,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },
    {
      "ImageURL": cajunChickenSalad,
      "Name": "Cajun Chicken Salad",
      "category": "Our Famous Salads",
      "dec": "Grilled cajun spiced chicken breast cut into strips served on a bed of fresh lettuce, tomatoes, green pepper, cucumber and red cabbage.",
      "KES": 1250,
      "RectImageURL": cajunChickenSaladRect,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },
    {
      "ImageURL": cjsMixedGreenSalad,
      "Name": "CJ’s Mixed Green Salad",
      "category": "Our Famous Salads",
      "dec": "Fresh crispy lettuce, tomatoes, avocado, green olives, red cabbage and cucumber. Accompanied with freshly baked bread rolls and butter.",
      "KES": 1000,
      "RectImageURL": cjsMixedGreenSaladRect,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },
    // {
    //   "ImageURL": caesarSalad,
    //   "Name": "Caesar Salad",
    //   "category": "Our Famous Salads",
    //   "dec": "Fresh crispy romaine lettuce, Parmesan cheese, chicken cubes and garlic croutons tossed in creamy Caesar dressing. Accompanied with freshly baked bread rolls and butter.",
    //   "KES": 1200,
    //   "RectImageURL": caesarSaladRect,
    //   "Upgrades": [
    //     { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
    //     { name: "Mayonnaise OR Feta Cheese", price: 230 },
    //     { name: "Avocado OR 1000 Island", price: 230 },
    //     { name: "Soup OR Grilled Mushrooms", price: 280 },
    //     { name: "Extra Turkey", price: 530 },
    //     { name: "Extra Egg", price: 180 },
    //     { name: "Coleslaw", price: 180 }

    //   ]
    // },
    {
      "ImageURL": turkeyWaldorf,
      "Name": "Turkey Waldorf",
      "category": "Our Famous Salads",
      "dec": "Chunks of turkey breast, fresh cut apples, chopped celery, honey toasted nuts, golden raisins, red grapes dressed in a creamy ranch dressing.",
      "KES": 1300,
      "RectImageURL": turkeyWaldorfRect,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },
    {
      "ImageURL": bbqRanchChickenSalad,
      "Name": "BBQ Ranch Chicken Salad",
      "category": "Our Famous Salads",
      "dec": "Chicken cubes, fresh avocado, tomato, sweet corn, cheddar cheese, fresh onions & black beans on a bed of lettuce, dressed with our BBQ ranch dressing & topped with crispy onion rings.",
      "KES": 1300,
      "RectImageURL": bbqRanchChickenSaladRect,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },
    {
      "ImageURL": cobbSalad,
      "Name": "Cobb Salad",
      "category": "Our Famous Salads",
      "dec": "Chicken cubes, boiled eggs, avocado, beef macon, kernels of corn, tomatoes, feta cheese on a bed of fresh crispy lettuce served with honey lime dressing. Accompanied with freshly baked bread rolls and butter.",
      "KES": 1300,
      "RectImageURL": cobbSaladRect,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },

    {
      "ImageURL": SantaFeSalad,
      "Name": "Santa Fe Salad",
      "category": "Our Famous Salads",
      "dec": "Mild spiced grilled chicken, black beans, cheddar cheese, sweet corn, tomatoes, avocado, cilantro, romaine lettuce, fried tortilla strips and a drizzle of Santa Fe dressing.",
      "KES": 1350,
      "RectImageURL": SantaFeSaladRect,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },

    {
      "ImageURL": GrilledSteakAvocadoSalad,
      "Name": "Grilled Chicken/Steak Avocado Salad",
      "category": "Our Famous Salads",
      "dec": "Tender grilled steak served over romaine lettuce with sun-dried tomatoes, fresh cucumber, juicy cherry tomatoes, yellow pepper, and a creamy avocado fan, finished with Parmesan for a perfectly satisfying bite.",
      "KES": 1300,
      "RectImageURL": GrilledSteakAvocadoSalad,
      "Upgrades": [
        { name: "Cubed Chicken OR Chicken Strips OR Beef Strips OR Fish Strips", price: 330 },
        { name: "Mayonnaise OR Feta Cheese", price: 230 },
        { name: "Avocado OR 1000 Island", price: 230 },
        { name: "Soup OR Grilled Mushrooms", price: 280 },
        { name: "Extra Turkey", price: 530 },
        { name: "Extra Egg", price: 180 },
        { name: "Coleslaw", price: 180 }

      ]
    },
    {
      "ImageURL": chickenAvocadoMLT,
      "Name": "Chicken Avocado LT",
      "category": "Scrumptious Sandwiches",
      "dec": "Grilled seasoned chicken breast sandwich with avocado, Tomato, Lettuce and Mayonnaise.",
      "KES": 1380,
      "RectImageURL": chickenAvocadoMLTRect,
      "Upgrades": [
        { name: "Substitute masala chips", price: 200 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Substitute your fries to Soup or Fruit bowl", price: 280 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Substitute your fries to Plantain", price: 230 }

      ]
    },
    {
      "ImageURL": cubanSandwich,
      "Name": "Cuban Sandwich",
      "category": "Scrumptious Sandwiches",
      "dec": "Marinated grilled chicken, roasted turkey breast, cheese, pickles, mustard mayonnaise and cranberry sauce.",
      "KES": 1380,
      "RectImageURL": cubanSandwichRect,
      "Upgrades": [
        { name: "Substitute masala chips", price: 200 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Substitute your fries to Soup or Fruit bowl", price: 280 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Substitute your fries to Plantain", price: 230 }

      ]
    },
    {
      "ImageURL": classicCheeseTomato,
      "Name": "Classic Cheese & Tomato",
      "category": "Scrumptious Sandwiches",
      "dec": "Triple decker sandwich with tomatoes, oregano, mayonnaise and cheddar cheese. With your choice of fresh daily baked white or brown bread and served with CJ's house salad or fresh cut fries.",
      "KES": 1150,
      "RectImageURL": classicCheeseTomatoRect,
      "Upgrades": [
        { name: "Substitute masala chips", price: 200 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Substitute your fries to Soup or Fruit bowl", price: 280 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Substitute your fries to Plantain", price: 230 }

      ]
    },
    {
      "ImageURL": bbqChickenSandwich,
      "Name": "BBQ Chicken Sandwich",
      "category": "Scrumptious Sandwiches",
      "dec": "Grilled chicken in BBQ sauce with melted cheese. With your choice of fresh daily baked white or brown bread.",
      "KES": 1380,
      "RectImageURL": bbqChickenSandwichRect,
      "Upgrades": [
        { name: "Substitute masala chips", price: 200 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Substitute your fries to Soup or Fruit bowl", price: 280 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Substitute your fries to Plantain", price: 230 }

      ]
    },
    {
      "ImageURL": grilledVegetableClub,
      "Name": "Grilled Vegetable Club",
      "category": "Scrumptious Sandwiches",
      "dec": "Grilled oyster mushrooms, green peppers, carrots, zucchini, mayonnaise and melted cheese. With your choice of fresh daily baked white or brown bread.",
      "KES": 1250,
      "RectImageURL": grilledVegetableClubRect,
      "Upgrades": [
        { name: "Substitute masala chips", price: 200 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Substitute your fries to Soup or Fruit bowl", price: 280 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Substitute your fries to Plantain", price: 230 }

      ]
    },
    {
      "ImageURL": phillyCheeseSteak,
      "Name": "Philly Cheese Steak",
      "category": "Scrumptious Sandwiches",
      "dec": "Tender beef strips, green peppers, onions sauteed in beef jus, and topped with melted mozzarella cheese. With your choice of fresh daily baked white or brown baguette.",
      "KES": 1380,
      "RectImageURL": phillyCheeseSteakRect,
      "Upgrades": [
        { name: "Substitute masala chips", price: 200 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Substitute your fries to Soup or Fruit bowl", price: 280 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Substitute your fries to Plantain", price: 230 }

      ]
    },
    {
      "ImageURL": cjsClubSandwich,
      "Name": "CJ’s Club Sandwich",
      "category": "Scrumptious Sandwiches",
      "dec": "Triple decker sandwich of sliced beef, grilled chicken breast, onions, tomatoes, mayonnaise and cheddar cheese. With your choice of fresh daily baked white or brown bread.",
      "KES": 1380,
      "RectImageURL": cjsClubSandwichRect,
      "Upgrades": [
        { name: "Substitute masala chips", price: 200 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Substitute your fries to Soup or Fruit bowl", price: 280 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Substitute your fries to Plantain", price: 230 }

      ]
    },

    {
      "ImageURL": BuffaloChickenWrapSqure,
      "Name": "Buffalo Chicken Wrap",
      "category": "Scrumptious Sandwiches",
      "dec": "A yummy wholewheat wrap filled with tasty crispy chicken strips tossed in a mild buffalo sauce, mayonnaise, lettuce and tomatoes.",
      "KES": 1380,
      "RectImageURL": BuffaloChickenWrapRect,
      "Upgrades": [
        { name: "Substitute masala chips", price: 200 },
        { name: "Substitute minced meat & cheese toppings", price: 280 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Substitute your fries to Soup or Fruit bowl", price: 280 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Substitute your fries to Plantain", price: 230 }

      ]
    },
    {
      "ImageURL": hawaiianBBQBurger,
      "Name": "Hawaiian BBQ Burger",
      "category": "Big-Mouth Burgers",
      "dec": "Chicken Breast/Beef Patty with Beef Macon, grilled pineapple, fresh onion rings, tomatoes, shredded lettuce, melted cheese, Hawaiian BBQ sauce with ranch dressing.",
      "KES": 1450,
      "RectImageURL": hawaiianBBQBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },
    {
      "ImageURL": friedCrispyChickenBurger,
      "Name": "Fried Crispy Chicken Burger",
      "category": "Big-Mouth Burgers",
      "dec": "Crispy fried chicken breast topped with coleslaw, Pickles, Mayonnaise & Bbq sauce in a fresh baked bun.",
      "KES": 1450,
      "RectImageURL": friedCrispyChickenBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },
    {
      "ImageURL": mexicanBurger,
      "Name": "Mexican Burger",
      "category": "Big-Mouth Burgers",
      "dec": "Choice of either beef or chicken with grilled green peppers, sliced tomatoes, jalapeños, tangy salsa, chilli mayo, lettuce and melted mozzarella cheese.",
      "KES": 1450,
      "RectImageURL": mexicanBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },
    {
      "ImageURL": bigIsBig,
      "Name": "Big Is Big",
      "category": "Big-Mouth Burgers",
      "dec": "A choice of chicken or beef, Fried egg, beef macon, crispy onion rings, crisp shredded lettuce, sliced tomato, cucumbers, pickles, cheese, ranch dressing, sauteed green peppers and onions.",
      "KES": 1550,
      "RectImageURL": bigIsBigRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },
    {
      "ImageURL": bbqBurger,
      "Name": "BBQ Burger",
      "category": "Big-Mouth Burgers",
      "dec": "Melted cheddar cheese with crispy onion rings and BBQ ranch sauce.",
      "KES": 1450,
      "RectImageURL": bbqBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },
    {
      "ImageURL": beefBurger,
      "Name": "Beef Burger Single",
      "category": "Big-Mouth Burgers",
      "dec": "Perfectly grilled beef patty with grilled onions, fresh tomatoes, mayonnaise and shredded lettuce.",
      "KES": 1300,
      "RectImageURL": beefBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },

    {
      "ImageURL": beefBurger,
      "Name": "Beef Burger Double",
      "category": "Big-Mouth Burgers",
      "dec": "Perfectly grilled beef patty with grilled onions, fresh tomatoes, mayonnaise and shredded lettuce.",
      "KES": 1450,
      "RectImageURL": beefBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },

    {
      "ImageURL": FishBurgerSqure,
      "Name": "Fish Burger",
      "category": "Big-Mouth Burgers",
      "dec": "A crispy fried Tilapia fillet seasoned to perfection topped with tomatoes, crispy fresh lettuce and tartar sauce.",
      "KES": 1450,
      "RectImageURL": FishBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },
    {
      "ImageURL": chickenBurgerSingle,
      "Name": "Chicken Burger Single",
      "category": "Big-Mouth Burgers",
      "dec": " Grilled chicken breast with crisp shredded lettuce, tomato, caramelized onion & mayonnaise.",
      "KES": 1300,
      "RectImageURL": chickenBurgerSingleRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },

    {
      "ImageURL": chickenBurger,
      "Name": "Chicken Burger Double",
      "category": "Big-Mouth Burgers",
      "dec": " Grilled chicken breast with crisp shredded lettuce, tomato, caramelized onion & mayonnaise.",
      "KES": 1450,
      "RectImageURL": chickenBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },
    {
      "ImageURL": vegetableBurger,
      "Name": "Vegetable Burger",
      "category": "Big-Mouth Burgers",
      "dec": "Vegetable patty, topped with tomatoes, crisp shredded lettuce.",
      "KES": 1150,
      "RectImageURL": vegetableBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },

    {
      "ImageURL": BuffaloBurgeSqure,
      "Name": "Buffalo Burger",
      "category": "Big-Mouth Burgers",
      "dec": "A juicy crispy chicken burger in mild buffalo sauce with lettuce, tomatoes sandwiched in a brioche bun.",
      "KES": 1450,
      "RectImageURL": BuffaloBurgerRect,
      "Upgrades": [
        { name: "Mushroom sauce OR Grilled pineapple OR fried egg OR pickles", price: 180 },
        { name: "Guacamole OR Avocado OR Jalapeños OR Salsa", price: 180 },
        { name: "BBQ sauce", price: 180 },
        { name: "Cheddar cheese OR Jack cheese", price: 230 },
        { name: "Beef strips", price: 330 },
        { name: "Add veggie OR chicken or beef patty", price: 180 },
        { name: "1000 island", price: 180 },
        { name: "Honey mustard", price: 180 }
      ]
    },
    {
      "ImageURL": caribbeanJerkChicken,
      "Name": "Caribbean Jerk Chicken",
      "category": "Chicken",
      "dec": "Marinated chicken on bone Caribbean style, grilled to perfection, served with salsa, plantains, salad, 1000 island dressing and ranchero sauce. With your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": caribbeanJerkChickenRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": stirFriedChicken,
      "Name": "Stir Fried Chicken",
      "category": "Chicken",
      "dec": "Strips of tender juicy chicken breast served with caeser salad, spinach and plantain.",
      "KES": 1800,
      "RectImageURL": stirFriedChickenRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": juicyGrilledChickenBreast,
      "Name": "Juicy Grilled Chicken Breast",
      "category": "Chicken",
      "dec": "Tender juicy marinated boneless chicken cooked to perfection served with salad, 1000 island dressing and beef gravy. With your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": juicyGrilledChickenBreastRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
   
    {
      "ImageURL": mushroomGrilledChickenBreast,
      "Name": "Mushroom Grilled Chicken Breast",
      "category": "Chicken",
      "dec": "Juicy grilled boneless chicken breast, served with mushroom sauce, salad and 1000 island dressing. With your choice of chips or rice or mashed potatoes.",
      "KES": 1900,
      "RectImageURL": mushroomGrilledChickenBreastRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": chickenWingMeal,
      "Name": "Chicken Wing Meal",
      "category": "Chicken",
      "dec": "Marinated grilled chicken wings with carrots, cucumber & dipping sauce. With your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": chickenWingMealRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    //BBQ Chicken Wing Meal

    {
      "ImageURL": BBQChickenWingMeal,
      "Name": "BBQ Chicken Wing Meal",
      "category": "Chicken",
      "dec": "Marinated grilled chicken wings tossed in BBQ sauce with carrots, cucumber sticks and honey mustard sauce. With your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": BBQChickenWingMealRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

// Lemon & Herb Chicken Wing Meal 
    {
      "ImageURL": LemonHerbChickenWingMealSqure,
      "Name": "Lemon & Herb Chicken Wing Meal ",
      "category": "Chicken",
      "dec": "Marinated grilled chicken wings hand tossed in juicy lemon and herb sauce served with carrots, cucumber & dipping sauce. Along with your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": LemonHerbChickenWingMealRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

    // Crispy Fried Chicken Wing Meal 
    {
      "ImageURL": CrispyFriedChickenWingMealSqure,
      "Name": "Crispy Fried Chicken Wing Meal ",
      "category": "Chicken",
      "dec": "Tender, crispy and breaded chicken wings served with carrots, cucumber & dipping sauce. Along with your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": CrispyFriedChickenWingMealRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": chickenSkewers,
      "Name": "Chicken Skewers",
      "category": "Chicken",
      "dec": "Marinated chicken skewers served with sweet corn, beef gravy, salsa and plantains. With your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": chickenSkewersRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": chickenTendersPlatter,
      "Name": "Chicken Tenders Platter",
      "category": "Chicken",
      "dec": "Tender, breaded chicken strips served with honey mustard and coleslaw. With your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": chickenTendersPlatterRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },

     // Turmeric Chicken

     {
      "ImageURL": TurmericChickenSqure,
      "Name": "Turmeric Chicken",
      "category": "Chicken",
      "dec": "Turmeric chicken with fried rice served with yellow sauce and salsa.",
      "KES": 1800,
      "RectImageURL": TurmericChickenRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    // BBQ Chicken

    {
      "ImageURL": BBQChickenSqure,
      "Name": "BBQ Chicken",
      "category": "Chicken",
      "dec": "Oven roasted chicken on bone smothered with a sweet & tangy BBQ sauce, served with chips, garlic bread and coleslaw salad.",
      "KES": 1800,
      "RectImageURL": BBQChickenRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    // Added Lemon & Herb Chicken
    {
      "ImageURL": LemonHerbChickenSqure,
      "Name": "Lemon & Herb Chicken",
      "category": "Chicken",
      "dec": "Tender juicy lemon and herb marinated chicken on bone cooked to perfection served with chapati, pilau, steamed vegetables, cucumber salsa and garden peas curry.",
      "KES": 1800,
      "RectImageURL": LemonHerbChickenRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },


    {
      "ImageURL": grilledTilapia,
      "Name": "Grilled Tilapia",
      "category": "Fish",
      "dec": "Fresh Tilapia fillet, grilled to perfection served with tangy rustica sauce and salad. With your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": grilledTilapiaRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": stirFriedTilapia,
      "Name": "Stir Fried Tilapia",
      "category": "Fish",
      "dec": "Strips of fresh tilapia served with caeser salad, spinach and plantain.",
      "KES": 1800,
      "RectImageURL": stirFriedTilapiaRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    // {
    //   "ImageURL": grilledSalmon,
    //   "Name": "Grilled Salmon",
    //   "category": "Fish",
    //   "dec": "Super simple grilled salmon served in a plate of stir fried vegetable rice with cilantro lime caper sauce.",
    //   "KES": 2400,
    //   "RectImageURL": grilledSalmonRect,
    //   "Upgrades": [
    //     { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
    //     { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
    //     { name: "Substitute with minced meat & cheese toppings", price: 280 },
    //     { name: "Substitute with Masala Chips", price: 200 },
    //     { name: "Substitute your fries with Sub Pasta", price: 280 },
    //     { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
    //     { name: "Substitute your fries with caesar salad", price: 280 },
    //     { name: "Add Onion Rings", price: 230 },
    //     { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
    //     { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
    //     { name: "Substitute with Garlic Parmesan Fries", price: 280 },
    //     { name: "Add Side Salad", price: 330 },
    //     { name: "Substitute your fries to Plantain", price: 230 },
    //     { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
    //   ]
    // },
    {
      "ImageURL": grilledCajunTilapia,
      "Name": "Grilled Cajun Tilapia",
      "category": "Fish",
      "dec": "Fresh cajun spiced tilapia fillet, grilled to perfection served with tangy rustica sauce and salad. With your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": grilledCajunTilapiaRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": rusticaGrilledFishFillet,
      "Name": "Rustica Grilled Fish Fillet",
      "category": "Fish",
      "dec": "Grilled tilapia on a bed of avocado, salsa, served with parsley potatoes, rustica sauce and black olives.",
      "KES": 1800,
      "RectImageURL": rusticaGrilledFishFilletRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": fishFingers,
      "Name": "Fish Fingers",
      "category": "Fish",
      "dec": "Deep fried breaded fish served with tartar sauce, 1000 island. With your choice of chips or rice or mashed potatoes.",
      "KES": 1800,
      "RectImageURL": fishFingersRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    // New add
    {
      "ImageURL": GrilledRedSnapper,
      "Name": "Grilled Red Snapper",
      "category": "Fish",
      "dec": "Fresh, succulent red snapper grilled to perfection and seasoned with a blend of aromatic herbs and spices.",
      "KES": 2200,
      "RectImageURL": GrilledRedSnapperRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": CajunRedSnapper,
      "Name": "Cajun Red Snapper",
      "category": "Fish",
      "dec": "Delicious red snapper seasoned with a robust Cajun spice blend and expertly grilled to perfection.",
      "KES": 2200,
      "RectImageURL": CajunRedSnapperRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": GrilledSalmon,
      "Name": "Grilled Salmon",
      "category": "Fish",
      "dec": "A boneless filet grilled with a light herb seasoning, served with rice and fresh garden salad.",
      "KES": 2400,
      "RectImageURL": GrilledSalmonRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    //done
    {
      "ImageURL": beefSteak,
      "Name": "Beef Steak",
      "category": "Beef",
      "dec": "Tender and juicy beef fillet steak cooked to your preference, served with salad, onion rings and beef gravy.",
      "KES": 1800,
      "RectImageURL": beefSteakRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": mushroomBeefSteak,
      "Name": "Mushroom Beef Steak",
      "category": "Beef",
      "dec": "Tender and juicy beef fillet steak cooked to your preference, served with salad and creamy mushroom sauce.",
      "KES": 1900,
      "RectImageURL": mushroomBeefSteakRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": pepperBeefSteak,
      "Name": "Pepper Beef Steak",
      "category": "Beef",
      "dec": "Tender and juicy beef fillet steak cooked to your preference, served with salad and creamy pepper sauce. With your choice of chips or rice or mashed potatoes.",
      "KES": 1900,
      "RectImageURL": pepperBeefSteakRect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
//new
    {
      "ImageURL": GralicBeefUgaliDelight,
      "Name": "Gralic Beef Ugali Delight",
      "category": "Beef",
      "dec": "Juicy diced beef sautéed with garlic and white onion, marinated in homemade spices, and served with ugali or your choice of starch.",
      "KES": 1900,
      "RectImageURL": GralicBeefUgaliDelight2025Rect,
      "Upgrades": [
        { name: "Substitute your juice with milkshake OR lemonade OR fresh orange juice", price: 0 }, // No price specified
        { name: "Substitute your fries with Mince Meat & Cheese Fries", price: 280 },
        { name: "Substitute with minced meat & cheese toppings", price: 280 },
        { name: "Substitute with Masala Chips", price: 200 },
        { name: "Substitute your fries with Sub Pasta", price: 280 },
        { name: "Add Tomato Salsa OR Guacamole OR Avocado", price: 180 },
        { name: "Substitute your fries with caesar salad", price: 280 },
        { name: "Add Onion Rings", price: 230 },
        { name: "Substitute your fries to Soup OR Fruit bowl", price: 280 },
        { name: "Add Fried Beans OR Steamed Spinach", price: 330 },
        { name: "Substitute with Garlic Parmesan Fries", price: 280 },
        { name: "Add Side Salad", price: 330 },
        { name: "Substitute your fries to Plantain", price: 230 },
        { name: "Add Mushroom Sauce OR Pepper Sauce", price: 180 }
      ]
    },
    {
      "ImageURL": madrasBeefCurry,
      "RectImageURL": madrasBeefCurryRect,
      "Name": "Madras Beef Curry",
      "category": "Curries",
      "dec": "Mild homemade beef curry with a hint of yogurt served with steamed vegetables and mango chutney. With your choice of rice, fries, mashed potatoes.",
      "KES": 1800,
      "Upgrades": [
        { name: "ADD Tomato salsa OR Guacamole OR Avocado", price: 180 },
        { name: "ADD Onion Rings", price: 230 },
        { name: "ADD Fried Beans OR Fried Spinach", price: 330 }
      ]
    },
    {
      "ImageURL": classicChickenKorma,
      "RectImageURL": classicChickenKormaRect,
      "Name": "Classic Chicken Korma",
      "category": "Curries",
      "dec": "Creamy mild coconut chicken curry served with steamed vegetables and mango chutney. With your choice of rice, fries or mashed potatoes.",
      "KES": 1800,
      "Upgrades": [
        { name: "ADD Tomato salsa OR Guacamole OR Avocado", price: 180 },
        { name: "ADD Onion Rings", price: 230 },
        { name: "ADD Fried Beans OR Fried Spinach", price: 330 }
      ]
    },
    {
      "ImageURL": theTrio,
      "RectImageURL": theTrioRect,
      "Name": "The Trio",
      "category": "Curries",
      "dec": "A combination of jerk chicken, grilled Tilapia and your choice of curry (except shrimp curry) served with fresh vegetables.",
      "KES": 1900,
      "Upgrades": [
        { name: "ADD Tomato salsa OR Guacamole OR Avocado", price: 180 },
        { name: "ADD Onion Rings", price: 230 },
        { name: "ADD Fried Beans OR Fried Spinach", price: 330 }
      ]
    },
    {
      "ImageURL": shrimpCurry,
      "RectImageURL": shrimpCurryRect,
      "Name": "Shrimp Curry",
      "category": "Curries",
      "dec": "Mild coconut and shrimp curry served with buttered basmati rice and steamed vegetables.",
      "KES": 2200,
      "Upgrades": [
        { name: "ADD Tomato salsa OR Guacamole OR Avocado", price: 180 },
        { name: "ADD Onion Rings", price: 230 },
        { name: "ADD Fried Beans OR Fried Spinach", price: 330 }
      ]
    },
    {
      "ImageURL": signatureFishCurry,
      "RectImageURL": signatureFishCurryRect,
      "Name": "CJ’s Signature Fish Curry",
      "category": "Curries",
      "dec": "Fresh Lake Victoria Tilapia cubes simmered in a creamy mild coconut curry served with steamed vegetables and mango chutney. With your choice of rice or fries, mashed potatoes.",
      "KES": 1800,
      "Upgrades": [
        { name: "ADD Tomato salsa OR Guacamole OR Avocado", price: 180 },
        { name: "ADD Onion Rings", price: 230 },
        { name: "ADD Fried Beans OR Fried Spinach", price: 330 }
      ]
    },
    {
      "ImageURL": splitDecision,
      "RectImageURL": splitDecisionRect,
      "Name": "Split Decision",
      "category": "Curries",
      "dec": "Half madras beef curry and half chicken korma served with mango chutney. With your choice of rice, fries, mashed potatoes.",
      "KES": 1800,
      "Upgrades": [
        { name: "ADD Tomato salsa OR Guacamole OR Avocado", price: 180 },
        { name: "ADD Onion Rings", price: 230 },
        { name: "ADD Fried Beans OR Fried Spinach", price: 330 }
      ]
    },
    {
      "ImageURL": thaiPeanutChickenCurry,
      "RectImageURL": thaiPeanutChickenCurryRect,
      "Name": "Thai Peanut Chicken Curry",
      "category": "Curries",
      "dec": "Boneless chicken cooked with peanut sauce and okra served with cinnamon plantains, salsa, salad and 1000 island dressing. With your choice of rice, fries or mashed potatoes.",
      "KES": 1800,
      "Upgrades": [
        { name: "ADD Tomato salsa OR Guacamole OR Avocado", price: 180 },
        { name: "ADD Onion Rings", price: 230 },
        { name: "ADD Fried Beans OR Fried Spinach", price: 330 }
      ]
    },
    {
      "ImageURL": vegetableCurry,
      "RectImageURL": vegetableCurryRect,
      "Name": "Vegetable Curry",
      "category": "Curries",
      "dec": "Chunks of fresh vegetables and paneer in a coconut curry sauce served with mango chutney. With your choice of rice or fries, mashed potatoes.",
      "KES": 1600,
      "Upgrades": [
        { name: "ADD Tomato salsa OR Guacamole OR Avocado", price: 180 },
        { name: "ADD Onion Rings", price: 230 },
        { name: "ADD Fried Beans OR Fried Spinach", price: 330 }
      ]
    },

    {
      "ImageURL": SalmonCurry,
      "RectImageURL": SalmonCurryRect,
      "Name": "Salmon Curry",
      "category": "Curries",
      "dec": "Salmon cooked in a delicious creamy mild coconut curry with buttered rice and steamed vegetables.",
      "KES": 2200,
      "Upgrades": [
        { name: "ADD Tomato salsa OR Guacamole OR Avocado", price: 180 },
        { name: "ADD Onion Rings", price: 230 },
        { name: "ADD Fried Beans OR Fried Spinach", price: 330 }
      ]
    },
    {
      "ImageURL": chipotleShrimpPasta,
      "RectImageURL": chipotleShrimpPastaRect,
      "Name": "Chipotle Shrimp Pasta",
      "category": "Pasta",
      "dec": "Penne pasta tossed in a chipotle cream sauce, accompanied with fresh daily-baked garlic bread.",
      "KES": 2100,
      "Upgrades": [
        { name: "ADD Parmesan cheese", price: 230 },
        { name: "ADD Beef strips", price: 330 },
        { name: "ADD Chicken strips", price: 330 }
      ]
    },
    {
      "ImageURL": chickenAlfredoPasta,
      "RectImageURL": chickenAlfredoPastaRect,
      "Name": "Chicken Alfredo Pasta",
      "category": "Pasta",
      "dec": "Rich parmesan cream sauce and chicken strips. With your choice of penne pasta or spaghetti. Accompanied with fresh, daily-baked garlic bread.",
      "KES": 1650,
      "Upgrades": [
        { name: "ADD Parmesan cheese", price: 230 },
        { name: "ADD Beef strips", price: 330 },
        { name: "ADD Chicken strips", price: 330 }
      ]
    },
    {
      "ImageURL": chipotleChickenPasta,
      "RectImageURL": chipotleChickenPastaRect,
      "Name": "Chipotle Chicken Pasta",
      "category": "Pasta",
      "dec": "Cajun spiced chicken strips, fresh vegetables, penne pasta tossed in a chipotle cream sauce. Accompanied with fresh, daily-baked garlic bread.",
      "KES": 1650,
      "Upgrades": [
        { name: "ADD Parmesan cheese", price: 230 },
        { name: "ADD Beef strips", price: 330 },
        { name: "ADD Chicken strips", price: 330 }
      ]
    },
    {
      "ImageURL": pastaPrimavera,
      "RectImageURL": pastaPrimaveraRect,
      "Name": "Pasta Primavera",
      "category": "Pasta",
      "dec": "Penne pasta tossed with market fresh garden vegetables served in a creamy white sauce. Accompanied with fresh, daily-baked garlic bread.",
      "KES": 1500,
      "Upgrades": [
        { name: "ADD Parmesan cheese", price: 230 },
        { name: "ADD Beef strips", price: 330 },
        { name: "ADD Chicken strips", price: 330 }
      ]
    },
  
    {
      "ImageURL": shrimpPasta,
      "RectImageURL": shrimpPastaRect,
      "Name": "Shrimp Pasta",
      "category": "Pasta",
      "dec": "Tagliatelle pasta tossed in tomato basil sauce with shrimp.",
      "KES": 2100,
      "Upgrades": [
        { name: "ADD Parmesan cheese", price: 230 },
        { name: "ADD Beef strips", price: 330 },
        { name: "ADD Chicken strips", price: 330 }
      ]
    },
    {
      "ImageURL": tuscanChicken,
      "RectImageURL": tuscanChickenRect,
      "Name": "Tuscan Chicken",
      "category": "Pasta",
      "dec": "Pan-fried chicken breast with a rich creamy garlic sauce, sundried tomatoes, spinach & parmesan cheese. Served with tagliatelle pasta.",
      "KES": 1650,
      "Upgrades": [
        { name: "ADD Parmesan cheese", price: 230 },
        { name: "ADD Beef strips", price: 330 },
        { name: "ADD Chicken strips", price: 330 }
      ]
    },

    {
      "ImageURL": JerkChickenPastaSqure,
      "RectImageURL": JerkChickenPastaReact,
      "Name": "Jerk Chicken Pasta",
      "category": "Pasta",
      "dec": "Chicken pasta in a delicious Carribean jerk sauce tossed with bell pepper, parmesan cheese, served with garlic toast.",
      "KES": 1650,
      "Upgrades": [
        { name: "ADD Parmesan cheese", price: 230 },
        { name: "ADD Beef strips", price: 330 },
        { name: "ADD Chicken strips", price: 330 }
      ]
    },
    {
      "ImageURL": southwesternQuesadilla,
      "RectImageURL": southwesternQuesadillaRect,
      "Name": "Southwestern Quesadilla",
      "category": "The Ever Tasty Mex-fix",
      "dec": "Marinated chicken or beef with grilled onions and mozzarella cheese in tortillas. Served with sour cream, salsa and guacamole.",
      "KES": 1500,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": softTacos,
      "RectImageURL": softTacosRect,
      "Name": "Soft Tacos",
      "category": "The Ever Tasty Mex-fix",
      "dec": "Three tacos shells stuffed with seasoned grilled chicken or beef or fish, topped with melted cheese, sliced avocado, tomato and cilantro.",
      "KES": 1500,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": vegetableMushroomQuesadilla,
      "RectImageURL": vegetableMushroomQuesadillaRect,
      "Name": "Vegetable Mushroom Quesadilla",
      "category": "The Ever Tasty Mex-fix",
      "dec": "Tortillas stuffed with grilled mushrooms, vegetables, and mozzarella cheese. Served with sour cream, salsa, and guacamole.",
      "KES": 1400,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": sizzlingFajitas,
      "RectImageURL": sizzlingFajitasRect,
      "Name": "Sizzling Fajitas",
      "category": "The Ever Tasty Mex-fix",
      "dec": "Marinated grilled chicken or steak or fish served in a sizzling skillet, with sautéed green peppers and onions. Accompanied with farm flour tortillas, cilantro lime rice, refried beans, sour cream, salsa and guacamole.",
      "KES": 1500,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": SalmonFajitas,
      "RectImageURL": SalmonFajitasRect,
      "Name": "Salmon Fajitas",
      "category": "The Ever Tasty Mex-fix",
      "dec": "Marinated grilled salmon served on a sizzling skillet with sauteed green peppers and onions. Accompanied with warm flour tortillas, cilantro lime rice, refried beans, sour cream, salsa and guacamole.",
      "KES": 2200,
      "Upgrades":[
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    
    {
      "ImageURL": vegetableSizzlingFajitas,
      "RectImageURL": vegetableSizzlingFajitasRect,
      "Name": "Vegetable Sizzling Fajitas",
      "category": "The Ever Tasty Mex-fix",
      "dec": "Flour tortillas stuffed with grilled mushrooms and vegetables. Served with sour cream, salsa, and guacamole.",
      "KES": 1400,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": nyamaFeastPizza,
      "RectImageURL": nyamaFeastPizzaRect,
      "Name": "Nyama Feast Pizza",
      "category": "Expertly Crafted Pizzas",
      "dec": "Beef Sausages, beef strips, chicken cubes, mushrooms, tomato and mozzarella cheese.",
      "KES": 1700,
      "Large": 1700,
      "Medium": 1400,

      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": margheritaPizza,
      "RectImageURL": margheritaPizzaRect,
      "Name": "Margherita Pizza",
      "category": "Expertly Crafted Pizzas",

      "dec": "Mozzarella cheese and tomato sauce on a freshly baked crust.",
      "KES": 1200,
      "Large": 1400,
      "Medium": 1200,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": vegetarianPizza,
      "RectImageURL": vegetarianPizzaRect,
      "Name": "Vegetarian Pizza",
      "category": "Expertly Crafted Pizzas",
      "dec": "Mozzarella cheese, onions, tomatoes, mushrooms, green peppers, black olives and tomato sauce on a freshly baked crust.",
      "KES": 1200,
      "Large": 1400,
      "Medium": 1200,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": mexicanChickenPizza,
      "RectImageURL": mexicanChickenPizzaRect,
      "Name": "Mexican Chicken Pizza",
      "category": "Expertly Crafted Pizzas",
      "dec": "Spiced chicken cubes, mozzarella cheese, onions, tomatoes, green peppers, tomato sauce and chili on a freshly baked crust.",
      "KES": 1300,
      "Large": 1600,
      "Medium": 1300,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": superSupremeChickenPizza,
      "RectImageURL": superSupremeChickenPizzaRect,
      "Name": "Super Supreme Chicken Pizza",
      "category": "Expertly Crafted Pizzas",
      "dec": "Chicken cubes, mozzarella cheese, onions, tomatoes, green peppers, tomato sauce and black olives on a freshly baked crust.",
      "KES": 1300,
      "Large": 1600,
      "Medium": 1300,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": chickenHawaiiPizza,
      "RectImageURL": chickenHawaiiPizzaRect,
      "Name": "Chicken Hawaii Pizza",
      "category": "Expertly Crafted Pizzas",
      "dec": "Chicken cubes, pineapples, BBQ sauce and mozzarella cheese on a freshly baked crust.",
      "KES": 1300,
      "Large": 1600,
      "Medium": 1300,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": jerkChickenPizza,
      "RectImageURL": jerkChickenPizzaRect,
      "Name": "Jerk Chicken Pizza",
      "category": "Expertly Crafted Pizzas",
      "dec": "Our signature Jerk Chicken, tomatoes, green pepper, onions and mozzarella cheese served with salsa.",
      "KES": 1300,
      "Large": 1600,
      "Medium": 1300,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },
    {
      "ImageURL": bbqChickenPizza,
      "RectImageURL": bbqChickenPizzaRect,
      "Name": "BBQ Chicken Pizza",
      "category": "Expertly Crafted Pizzas",
      "dec": "BBQ chicken cubes, BBQ sauce, onions, tomatoes, green peppers, and mozzarella cheese on a freshly baked crust.",
      "KES": 1300,
      "Large": 1600,
      "Medium": 1300,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },

    {
      "ImageURL": SeafoodPizzaSqure,
      "RectImageURL": SeafoodPizzaRect,
      "Name": "Seafood Pizza",
      "category": "Expertly Crafted Pizzas",
      "dec": "Scrumptious pizza prepared with lots of yummy shrimps and salmon, the best soft, chewy crust and red sauce.",
      "KES": 1300,
      "Large": 2250,
      "Medium": 1800,
      "Upgrades": [
        { name: "Mozzarella Cheese OR Onion Rings", price: 230 },
        { name: "Salsa OR Jalapeños OR Guacamole", price: 180 },
        { name: "Fried Beans", price: 330 },
        { name: "Side Salad", price: 330 },
        { name: "Substitute Masala fries", price: 200 },
        { name: "Substitute your fries to plantain", price: 230 }
      ]
    },

    {
      "ImageURL": kiddieChickenStrips,
      "RectImageURL": kiddieChickenStripsRect,
      "Name": "Kiddie Chicken Strips",
      "category": "Kiddie Meals",
      "dec": "Crispy fried chicken with assorted vegetables. With your choice of mashed potatoes or fries.",
      "KES": 880,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": kiddieChickenBurger,
      "RectImageURL": kiddieChickenBurgerRect,
      "Name": "Kiddie Burger",
      "category": "Kiddie Meals",
      "dec": "Either beef or chicken pattie with mayonnaise, tomato, lettuce on a fresh bun. Served with CJ's fries.",
      "KES": 780,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": kiddieTommyFishFingers,
      "RectImageURL": kiddieTommyFishFingersRect,
      "Name": "Kiddie Tommy Fish Fingers",
      "category": "Kiddie Meals",
      "dec": "Fish fingers served with non-spiced chips, tartar sauce, and coleslaw.",
      "KES": 880,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": kiddiePastaMaster,
      "RectImageURL": kiddiePastaMasterRect,
      "Name": "Kiddie Pasta Master",
      "category": "Kiddie Meals",
      "dec": "Penne with creamy mushroom sauce and chicken strips served with garlic bread.",
      "KES": 880,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": kiddieSausageWorld,
      "RectImageURL": kiddieSausageWorldRect,
      "Name": "Kiddie Sausage World",
      "category": "Kiddie Meals",
      "dec": "Sausages served with non-spiced fries and coleslaw.",
      "KES": 680,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": KiddiePanFriedTilapiaFillet,
      "RectImageURL": KiddiePanFriedTilapiaFilletRect,
      "Name": "Kiddie Pan Fried Tilapia Fillet",
      "category": "Kiddie Meals",
      "dec": "Pan-fried tilapia. Assorted vegetables with a choice of mashed potato or fries.",
      "KES": 820,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": kiddieFries,
      "RectImageURL": kiddieFriesRect,
      "Name": "Kiddie Fries",
      "category": "Kiddie Meals",
      "dec": "Fresh crispy non-spiced fries with coleslaw.",
      "KES": 290,
      "Upgrades": [

      ]
    },
    // {
    //   "ImageURL": jerkAndJillChicken,
    //   "RectImageURL": jerkAndJillChickenRect,
    //   "Name": "Jerk & Jill Chicken",
    //   "category": "Kiddie Meals",
    //   "dec": "Chicken on Bone, grilled to perfection, served with chips and coleslaw with a choice of mashed potatoes or fries.",
    //   "KES": 880,
    //   "Upgrades":[

    //   ]
    // },
    // {
    //   "ImageURL": panFriedTilapiaFillet,
    //   "RectImageURL": panFriedTilapiaFilletRect,
    //   "Name": "Pan Fried Tilapia Fillet",
    //   "category": "Kiddie Meals",
    //   "dec": "Crispy fried fish, assorted vegetables, with a choice of mashed potatoes or fries.",
    //   "KES": 880,
    //   "Upgrades": [

    //   ]
    // },
    {
      "ImageURL": mashedPotatoes,
      "RectImageURL": mashedPotatoesRect,
      "Name": "Mashed Potatoes",
      "category": "Extras",
      "dec": "Mashed Potatoes.",
      "KES": 290,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": coleslaw,
      "RectImageURL": coleslawRect,
      "Name": "Coleslaw",
      "category": "Extras",
      "dec": "Coleslaw.",
      "KES": 180,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": steamedRice,
      "RectImageURL": steamedRiceRect,
      "Name": "Steamed Rice",
      "category": "Extras",
      "dec": "Steamed white rice.",
      "KES": 290,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": mexicanRice,
      "RectImageURL": mexicanRiceRect,
      "Name": "Mexican Rice",
      "category": "Extras",
      "dec": "Brown rice.",
      "KES": 300,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": steamedVeggies,
      "RectImageURL": steamedVeggiesRect,
      "Name": "Steamed Veggies",
      "category": "Extras",
      "dec": "Steamed Veggies.",
      "KES": 350,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": sideSalad,
      "RectImageURL": sideSaladRect,
      "Name": "Side Salad",
      "category": "Extras",
      "dec": "Side Salad.",
      "KES": 330,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": salsa,
      "RectImageURL": salsaRect,
      "Name": "Salsa",
      "category": "Extras",
      "dec": "A fine mix of chopped tomatoes & onions.",
      "KES": 180,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": creamyMushroomSauce,
      "RectImageURL": creamyMushroomSauceRect,
      "Name": "Creamy Mushroom Sauce",
      "category": "Extras",
      "dec": "Creamy Mushroom Sauce.",
      "KES": 180,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": chapati,
      "RectImageURL": chapatiRect,
      "Name": "Chapati",
      "category": "Extras",
      "dec": "Chapati",
      "KES": 180,
      "Upgrades": [

      ]
    },
    {
      "ImageURL": beefStrips,
      "RectImageURL": beefStripsRect,
      "Name": "Beef Strips",
      "category": "Extras",
      "dec": "Beef Strips",
      "KES": 330,
      "Upgrades": [

      ]
    }
  ]

}


export default GenerousBigMeals